import { HOME, ASSESSMENT_TITLES } from '@constants/titles.constant';

export class AssessmentPage {
  public breadcrumb = [HOME, ASSESSMENT_TITLES.name];
}
